/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-shadow */
import { FunctionComponent, useState, useEffect } from 'react';
import styles from './SlideShow.module.scss';
import Dots from './Dots/Dots';

export type SlideShowProps = {
  Content: React.JSX.Element[];
  haveNoDots?: boolean;
  padding?: string;
  isAutomatic?: boolean;
  newIndex?: number;
  onChangeIndex?: (index: number) => void;
};

type FC = FunctionComponent<SlideShowProps>;

const SlideShow: FC = (props: SlideShowProps) => {
  const { Content, haveNoDots = true, padding, isAutomatic = true, newIndex, onChangeIndex = () => {} } = props;
  const slidesCount = Content.length;
  const [index, setIndex] = useState(0);
  const [touchPosition, setTouchPosition] = useState(0);

  const changeIndex = (newIndex: number) => {
    if (newIndex < 0) {
      newIndex = slidesCount - 1;
    } else if (newIndex >= slidesCount) {
      newIndex = 0;
    }
    onChangeIndex(newIndex);
    setIndex(newIndex);
  };

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (touchPosition === 0) return;

    const currentPosition = e.touches[0].clientX;
    const direction = touchPosition - currentPosition;

    if (direction > 5) {
      changeIndex(index + 1);
    }

    if (direction < -5) {
      changeIndex(index - 1);
    }

    setTouchPosition(0);
  };

  useEffect(() => {
    if (typeof newIndex === 'number' && newIndex !== index) {
      changeIndex(newIndex);
    }
  }, [newIndex]);

  useEffect(() => {
    let changeSlide: number | undefined;

    if (isAutomatic) {
      changeSlide = window.setInterval(() => {
        changeIndex(index + 1);
      }, 5000);
    }

    return () => {
      if (changeSlide) {
        window.clearInterval(changeSlide);
      }
    };
  }, [index, isAutomatic]);

  return (
    <div className={styles.container} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove}>
      <div className={styles.inner} style={{ transform: `translateX(-${index * 100}%)` }}>
        {Object.values(Content).map((slide, index) => (
          <div key={index} className={styles.slide} style={{ padding }}>
            {slide}
          </div>
        ))}
      </div>
      {!haveNoDots && <Dots index={index} slidesCount={slidesCount} changeIndex={changeIndex} />}
    </div>
  );
};

export default SlideShow;
